import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  const isLarge = size === 'large';

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div
        className={`relative overflow-hidden rounded-lg bg-background-100 ${
          isLarge ? 'aspect-[3/4]' : 'aspect-[3/4]'
        }`}
      >
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          title={`${comic.title} - 古风漫画网免费韩国漫画在线阅读`}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute top-2 left-2">
          <span className={`text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${
            comic.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {comic.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-background-50 text-xs line-clamp-2 leading-relaxed">{comic.description}</p>
        </div>
      </div>

      <div className="mt-3">
        <h3 className={`font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 ${
          isLarge ? 'text-base' : 'text-sm'
        }`}>
          {comic.title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-xs text-foreground-400">|</span>
          <span className="text-xs text-foreground-500">{comic.category}</span>
        </div>
        <div className="flex items-center gap-2 mt-1.5">
          <div className="flex items-center gap-0.5">
            <i className="ri-star-fill text-xs text-accent-500"></i>
            <span className="text-xs text-accent-500 font-medium">{comic.rating}</span>
          </div>
          <span className="text-xs text-foreground-400">|</span>
          <span className="text-xs text-foreground-500">
            {comic.totalViews > 10000
              ? `${(comic.totalViews / 10000).toFixed(1)}万`
              : comic.totalViews}{' '}
            阅读
          </span>
        </div>
      </div>
    </Link>
  );
}